import { Component, EventEmitter, Input, Output } from "@angular/core";

@Component({
  selector: "app-params-certificado",
  templateUrl: "./certificado.component.html",
})
export class ParamLicenciasCertificadoComponent {
  public certificado: any;
  public paisId;
  public denominacionId;
  public almacenId;
  public licenciaSwId;

  public editable = false;

  @Input() set certificados(param: any) {
    if (param) {
      this.certificado = {
        modoCertificado: param.modoCertificado,
        modoEtiquetas: param.modoEtiquetas,
      };

      this.licenciaSwId = param.licenciaSwId;
      this.paisId = param.paisId;
      this.denominacionId = param.denominacionId;
      this.almacenId = param.almacenId;
    }
  }

  @Output() refresh = new EventEmitter<boolean>();
  @Output() pushMessage = new EventEmitter<string>();

  constructor() {}

  public editableChanged(editable) {
    this.editable = editable;
  }

  public toRefresh(value) {
    this.refresh.emit(value);
  }
}
